/**
 * Derives the same step title/description UI state as useStepFlow (onboarding Steps card).
 */
export function computeStepUiState({ flow, stepsConfig, ask3QuestionsCount }) {
  if (!flow || !stepsConfig?.length) return null;

  const stepsMap = new Map();
  stepsConfig.forEach((step) => stepsMap.set(step.id, step));

  const currentStepId = flow.currentStepId || null;
  const completedStepId = flow.completedStepId || null;
  const showCompletedState = flow.showCompletedState || false;
  const nrOfSteps = flow.nrOfSteps || stepsConfig.length;

  const displayStepId = showCompletedState && completedStepId ? completedStepId : currentStepId;
  const displayStep = displayStepId ? stepsMap.get(displayStepId) : null;
  const displayStepIndex = displayStepId
    ? stepsConfig.findIndex((step) => step.id === displayStepId)
    : -1;

  const isCompletedDisplay = showCompletedState && completedStepId === displayStepId;

  if (!displayStep || displayStepIndex < 0) return null;

  let stepDescription = displayStep.description;
  if (!isCompletedDisplay && displayStep.getDescription) {
    stepDescription = displayStep.getDescription(ask3QuestionsCount);
  }

  let stepTitle = displayStep.title;
  if (!isCompletedDisplay && displayStep.getTitle) {
    stepTitle = displayStep.getTitle(ask3QuestionsCount);
  }

  return {
    currentStep: displayStepIndex + 1,
    totalSteps: nrOfSteps,
    stepTitle: isCompletedDisplay ? displayStep.completedTitle : stepTitle,
    stepDescription: isCompletedDisplay ? displayStep.completedDescription : stepDescription,
    isCompleted: isCompletedDisplay,
    currentStepId: displayStep.id
  };
}
